import { BROCHURE_PDF, ENROLL_FORM, PARTNER_FORM } from '../forms';

const features = [
  {
    label: 'Industry Designed Programs',
    icon: (
      <svg viewBox="0 0 48 48" fill="none" className="h-8 w-8 sm:h-10 sm:w-10" aria-hidden="true">
        <circle cx="24" cy="20" r="8" stroke="currentColor" strokeWidth="2" />
        <path d="M12 38c0-6.627 5.373-12 12-12s12 5.373 12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        <path d="M30 14l2-4 4 1-2 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <circle cx="34" cy="10" r="2" fill="currentColor" />
      </svg>
    ),
  },
  {
    label: 'Big 4 & Fortune 500 Mentors',
    icon: (
      <svg viewBox="0 0 48 48" fill="none" className="h-8 w-8 sm:h-10 sm:w-10" aria-hidden="true">
        <circle cx="16" cy="18" r="5" stroke="currentColor" strokeWidth="2" />
        <circle cx="32" cy="18" r="5" stroke="currentColor" strokeWidth="2" />
        <path d="M8 36c0-4.418 3.582-8 8-8s8 3.582 8 8M24 36c0-4.418 3.582-8 8-8s8 3.582 8 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    label: 'Live Projects & Internships',
    icon: (
      <svg viewBox="0 0 48 48" fill="none" className="h-8 w-8 sm:h-10 sm:w-10" aria-hidden="true">
        <rect x="10" y="14" width="28" height="22" rx="2" stroke="currentColor" strokeWidth="2" />
        <path d="M18 14v-4a2 2 0 012-2h8a2 2 0 012 2v4" stroke="currentColor" strokeWidth="2" />
        <path d="M24 24v6M21 27h6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    label: 'Placement Assistance',
    icon: (
      <svg viewBox="0 0 48 48" fill="none" className="h-8 w-8 sm:h-10 sm:w-10" aria-hidden="true">
        <path d="M24 6L8 14v10c0 9.389 6.745 17.454 16 19 9.255-1.546 16-9.611 16-19V14L24 6z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
        <path d="M18 24l4 4 8-8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
];

function Hero() {
  return (
    <section className="relative overflow-hidden bg-brand-white">
      <img
        src="/images/hero-bg.png"
        alt=""
        className="absolute inset-0 hidden h-full w-full object-cover object-right lg:block"
        aria-hidden="true"
      />
      <div className="absolute inset-0 hidden bg-gradient-to-r from-brand-white via-brand-white/95 to-transparent lg:block lg:from-brand-white lg:via-brand-white/80 lg:to-transparent xl:via-brand-white/55" />

      <div className="relative h-48 w-full sm:h-56 lg:hidden">
        <img
          src="/images/hero-bg.png"
          alt="Students looking toward a bright future"
          className="h-full w-full object-cover object-center"
        />
      </div>

      <div className="page-shell relative z-10 flex min-h-0 items-center lg:min-h-[560px] xl:min-h-[620px]">
        <div className="w-full max-w-xl">
          <div className="mb-4 max-w-[280px] sm:mb-6 sm:max-w-[380px] lg:max-w-[460px]">
            <img
              src="/images/futureleadx-header.png"
              alt="FutureLeadX"
              className="h-auto w-full object-contain object-left"
            />
          </div>

          <h1 className="text-hero-heading mb-4 sm:mb-5">
            <span className="block text-brand-navy">Learn Today.</span>
            <span className="block text-brand-primary">Lead Tomorrow.</span>
          </h1>

          <p className="mb-6 max-w-[520px] text-body-sm text-brand-secondary sm:mb-7 sm:text-body">
            Industry-ready skills, real-world experience, expert mentorship,
            internships, placements and career transformation – all under one
            platform.
          </p>

          <div className="mb-8 flex flex-col gap-3 sm:flex-row sm:flex-wrap sm:items-center">
            <a
              href={ENROLL_FORM}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary w-full text-center sm:w-auto"
            >
              Enroll Now
            </a>
            <a
              href={PARTNER_FORM}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-outline w-full text-center sm:w-auto"
            >
              Partner With Us
            </a>
            <a
              href={BROCHURE_PDF}
              download="FutureLeadX-Roadmap.pdf"
              className="btn-outline flex w-full items-center justify-center gap-2 sm:w-auto"
            >
              <svg viewBox="0 0 20 20" fill="currentColor" className="h-4 w-4 shrink-0" aria-hidden="true">
                <path fillRule="evenodd" d="M4 4a2 2 0 012-2h4.586a1 1 0 01.707.293l4.414 4.414a1 1 0 01.293.707V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 0v12h8V8.414L11.586 4H6z" clipRule="evenodd" />
              </svg>
              Download Roadmap
            </a>
            <a
              href={BROCHURE_PDF}
              download="FutureLeadX-Brochure.pdf"
              className="btn-outline flex w-full items-center justify-center gap-2 sm:w-auto"
            >
              <svg viewBox="0 0 20 20" fill="currentColor" className="h-4 w-4 shrink-0" aria-hidden="true">
                <path fillRule="evenodd" d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" clipRule="evenodd" />
              </svg>
              Download Brochure
            </a>
          </div>

          <div className="grid grid-cols-2 gap-4 sm:grid-cols-4 sm:gap-4">
            {features.map((feature) => (
              <div key={feature.label} className="flex flex-col items-center text-center">
                <div className="mb-2 text-brand-primary">{feature.icon}</div>
                <p className="text-[11px] font-semibold leading-snug text-brand-navy sm:text-label lg:text-body-sm">
                  {feature.label}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
